import { BackendError } from './base';

class NotAnAdministrator extends BackendError {}

export default { NotAnAdministrator };
